/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const BillingSettingsFeatureName = {
    AUTO_RECEIPT_TRANSACTION_MATCHING: 'AUTO_RECEIPT_TRANSACTION_MATCHING',
    ERP_INTEGRATION_BUSINESS_CENTRAL: 'ERP_INTEGRATION_BUSINESS_CENTRAL',
    ERP_INTEGRATION_VISMA_NET: 'ERP_INTEGRATION_VISMA_NET',
    AUTO_RULES: 'AUTO_RULES',
    OUTLAY: 'OUTLAY',
    MILEAGE: 'MILEAGE',
    TRAVEL_ALLOWANCE: 'TRAVEL_ALLOWANCE',
    GASOLINE_INTERPRETATION: 'GASOLINE_INTERPRETATION',
    CARD_TRANSACTION_AI: 'CARD_TRANSACTION_AI',
    PERSONAL_CARDS: 'PERSONAL_CARDS',
    PASSKEY: 'PASSKEY',
    AGENCY_PORTAL: 'AGENCY_PORTAL',
    AI_AGENT: 'AI_AGENT',
    DIGITAL_RECEIPT: 'DIGITAL_RECEIPT',
    PAYOUT_REPORT: 'PAYOUT_REPORT',
    ALLOWANCE: 'ALLOWANCE',
    AGENCY_PORTAL_TEAMS: 'AGENCY_PORTAL_TEAMS',
    OUTLAY_CONFIG: 'OUTLAY_CONFIG',
    MILEAGE_CONFIG: 'MILEAGE_CONFIG',
    PER_DIEM_CONFIG: 'PER_DIEM_CONFIG'
} as const;

export type BillingSettingsFeatureName = typeof BillingSettingsFeatureName[keyof typeof BillingSettingsFeatureName];



